import { propertyManagingAgentCard } from '../../shared';
import type { ListingLocaleOverrides } from '../base';
import {
  buyersAttorneyContactCard,
  sellersAttorneyContactCard,
} from '../cards';

export const NYOverrides: ListingLocaleOverrides = {
  locale: 'NY',
  sections: {
    sellerSideContacts: {
      cards: {
        sellersAgentCard: {
          fields: {
            licenseNumber: {
              disabledForIndex: -1,
            },
          },
        },
        sellersAttorneyContactCard,
      },
    },
    buyerSideContacts: {
      cards: {
        buyersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: propertyManagingAgentCard,
        addAdditionalContactCard: {
          fields: {
            newContact: {
              options: (options) => [
                {
                  label: 'Property Managing Agent',
                  value: 'additionalContacts.propertyManagingAgent',
                },
                ...options.slice(1),
              ],
            },
          },
        },
      },
    },
  },
};
